import React from 'react';

export default class CustomDropdown extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showDropdown: false
        };
    }

    toggleDropdown() {
        this.setState({ showDropdown: !this.state.showDropdown });
    }

    selectOption(key, value, event) {
        if (event.target.className.includes("action")) {
            this.props.action(key, value);
        } else {
            this.props.onSelect(key);
            this.toggleDropdown();
        }
    }

    render() {
        return (
            <div className="custom-dropdown">
                <button className="btn btn-flat" disabled={this.props.loadingSearch} onClick={this.toggleDropdown.bind(this)}>
                    {this.props.loading ? "Loading..." : this.props.selection || this.props.placeholder}
                    <i className={`"icon icon-right ion-android-arrow-drop${this.state.showDropdown ? "up" : "down"}`}></i>
                </button>
                <div hidden={!this.state.showDropdown} className="custom-dropdown-box">
                    {
                        (this.props.options && this.props.options.length) ? this.props.options.map(option => <div key={option.key} className="custom-dropdown-option" onClick={this.selectOption.bind(this, option.key, option.value)}>
                            <div className="flex-justify">
                                <p className="medium-text">{option.value}</p>
                                {this.props.actionIcon}
                            </div>
                        </div>) : <span>No Searches</span>
                    }
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/commonComponents/util/CustomDropdown.jsx